var map = {
	"./ar.webp": 37229,
	"./da.webp": 59613,
	"./de.webp": 68105,
	"./en.webp": 76205,
	"./es-419.webp": 86433,
	"./es.webp": 61206,
	"./fr.webp": 58142,
	"./it.webp": 77783,
	"./ja.webp": 8947,
	"./nb.webp": 15974,
	"./nl.webp": 8224,
	"./pl.webp": 82522,
	"./pt.webp": 96194,
	"./sv.webp": 74439,
	"./tr.webp": 46960
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72141;